var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading.user,
      expression: "loading.user"
    }],
    attrs: {
      "title": "Edit Dashboard",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "120px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Owner"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: _vm.item.email,
      callback: function ($$v) {
        _vm.$set(_vm.item, "email", $$v);
      },
      expression: "item.email"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Notes"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": "",
      "placeholder": "Please input"
    },
    model: {
      value: _vm.payload.notes,
      callback: function ($$v) {
        _vm.$set(_vm.payload, "notes", $$v);
      },
      expression: "payload.notes"
    }
  })], 1), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }